<template>
  <div class="content">
    <div class="top">
      <el-card class="cards">
        <img class="vedio_img" src="@/assets/img/ve3.png">
        <div class="datas">
          <div>{{ vedioObj.accumulated_viewing_duration |getMinute }}<span class="tips">min</span></div>
          <div class="name">总学习时长</div>
        </div>
      </el-card>
      <el-card class="cards">
        <img class="vedio_img" src="@/assets/img/ve1.png">
        <div class="datas">
          <div>{{ vedioObj.completed }}<span class="tips">个</span></div>
          <div class="name">已完成学习</div>
        </div>
      </el-card>
      <el-card class="cards">
        <img class="vedio_img" src="@/assets/img/ve4.png">
        <div class="datas">
          <div>{{ vedioObj.in_progress }}<span class="tips">个</span></div>
          <div class="name">学习中视频</div>
        </div>
      </el-card>
      <el-card class="cards">
        <img class="vedio_img" src="@/assets/img/ve2.png">
        <div class="datas">
          <div>{{ vedioObj.not_start }}<span class="tips">个</span></div>
          <div class="name">未开始学习</div>
        </div>
      </el-card>
    </div>
    <el-card style="height: 100%" class="card2">
      <el-form v-if="userInfo.hospital_id" ref="queryForm" class="formClass" :model="queryParams" label-position="top">
        <div class="formTop">
          <div class="formInput">
            <el-form-item label="输入搜索" prop="title">
              <el-input v-model="queryParams.title" placeholder="视频名称" clearable size="small" />
            </el-form-item>
            <el-form-item label="项目" prop="app_id">
              <el-select v-model="queryParams.app_id" placeholder="请选择项目" clearable size="small">
                <el-option v-for="dict in subjectList" :key="dict.value" :label="dict.label" :value="dict.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="分类" prop="section_id">
              <el-select v-model="queryParams.section_id" placeholder="请选择分类" clearable size="small">
                <el-option v-for="dict in typeList" :key="dict.id" :label="dict.title" :value="dict.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="学习状态" prop="status">
              <el-select v-model="queryParams.status" placeholder="请选择学习状态" clearable size="small">
                <el-option v-for="(it,index) in stydyOptinon" :key="index" :label="it.title" :value="it.id" />
              </el-select>
            </el-form-item>
          </div>
          <el-form-item class="btn_item" prop="">
            <el-button type="primary" size="small" @click="()=>{queryParams.page=1,getList()}">搜索</el-button>
            <el-button size="small" @click="resetQuery">清空</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div v-if="vedioList&&vedioList.length>0" class="vedio_list">
        <div v-for="(item,index) in vedioList" :key="index" class="vedio_item">
          <div class="titles">
            <div class="name">
              <span v-if="item.topping==1" class="tip">置顶</span>
              <div class="name_set">{{ item.title }}</div></div>
            <div :class="item.study_status==1?'status':item.study_status==2?'status2':'status3'">{{ item.study_status==1?'未开始':item.study_status==2?'进行中':'已完成' }}</div>
          </div>
          <div class="vedio_content">
            <div class="vedio_conten_center">
              <div class="vedio_left">
                <div class="vedio_box" @click="play(item)">
                  <img :src="item.thumb" class="vedio_imgs">
                  <img src="@/assets/img/play.png" class="play">
                </div>
                <div class="vedio_info">
                  <div class="vedio_title">
                    <span>视频总时长：{{ item.duration | getTime }}</span>
                    <span>任务点：{{ item.task_point }}%</span>
                  </div>
                  <div class="vedio_num">
                    <div class="item">累计学习时间：{{ item.accumulated_viewing_duration | getMinute }}分钟</div>
                    <div>上次学习时间：{{ item.last_viewing_at?item.last_viewing_at:'无' }}</div>
                  </div>
                </div>
                <div class="bor" />
              </div>
              <div class="vedio_right">
                <div class="infos">
                  <div class="title">当前学习进度</div>
                  <div :class="item.study_status==1?'rate1':item.study_status==2?'rate2':'rate3'">{{ item.study_rate }}%</div>
                  <div class="bors" />
                  <div class="title">已观看时长</div>
                  <div :class="item.study_status==1?'time1':'time2'">{{ item.viewing_duration | getTime }}</div>
                </div>
              </div>
            </div>
            <div class="vedio_conten_bottom">
              <div class="section">视频分类：<span class="name">{{ item.section&&item.section.length>0?item.section.join(','):'无' }}</span></div>
              <div>所属项目：<span class="name">{{ item.app_str?item.app_str:'无' }}</span></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="nodata">
        <img src="@/assets/img/bg.png" class="img">
        <div class="tips">暂无数据</div>
      </div>
      <pagination
        v-show="queryParams.total > 0"
        :total="queryParams.total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.size"
        @pagination="getList"
      />
      <Tips :tip-parmas="tipParmas" @confirm="tipsClose" @cancel="tipsClose" />
    </el-card>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination'
import { getApps } from '@/http/index'
import { userVideoStatistics, userVideoList, getSectionList, getVideo } from '@/http/index'
import Tips from './child/tips.vue'
import {  fullScreen } from '@/utils/exam'
import { mapState } from 'vuex';
export default {
  components: { Pagination, Tips },
  filters: {
    getTime(val) {
      if (val) {
        var hours = Math.floor(val / 3600);
        var minutes = Math.floor((val % 3600) / 60);
        var remainingSeconds = val % 60;
        return hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0') + ":" + remainingSeconds.toString().padStart(2, '0')
      } else {
        return '00:00:00'
      }
    },
    getMinute(val) {
      if (val) {
        return Math.floor(val / 60)
      } else {
        return 0
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/home/play') {
      next(vm => {
        vm.queryParams = JSON.parse(sessionStorage.getItem('searchInfo'))
        sessionStorage.removeItem('searchInfo')
      })
      return
    } else {
      sessionStorage.removeItem('searchInfo')
      next();
    }
  },
  computed: {
    ...mapState(['userInfo',])
  },
  data() {
    return {
      tipParmas: {
        tipsVisible: false,
        code: 0
      },
      queryParams: {
        page: 1,
        size: 10,
        title: '',
        app_id: '',
        section_id: "",
        status: '',
        total: 0

      },
      subjectList: [],
      typeList: [],
      stydyOptinon: [
        { id: "", title: "全部" },
        { id: "1", title: "未开始" },
        { id: "2", title: "进行中" },
        { id: "3", title: "已完成" }],
      vedioList: [],
      vedioObj: {}
    }
  },
  mounted() {
    if (localStorage.getItem('hospital_id')) {
      this.getIdenticalList();
      this.getTypeList();
      this.getInfo();
      this.getList();
    }
  },
  methods: {
    tipsClose() {
      this.tipParmas.tipsVisible = false;
    },
    getVideoName(data) {
      const arr = [{
        name: '流畅',
        value: 'FD'
      }, {
        name: '标清',
        value: 'LD'
      }, {
        name: '高清',
        value: 'SD'
      }, {
        name: '超清',
        value: 'HD'
      }, {
        name: '原画',
        value: 'OD'
      }]
      return arr.find(item => item.value === data).name
    },
    async play(data) {
      const res = await getVideo({
        id: data.id,
        hospital_id: localStorage.getItem('hospital_id'),
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret')
      })
      if (res.data.playurl) {
        const videoList = []
        res.data.playurl.map(item => {
          videoList.push({
            name: this.getVideoName(item.Definition),
            PlayURL: item.PlayURL
          })
        })
        const obj = {
          src: videoList,
          id: data.id,
          viewingDuration: data.viewing_duration,
          doubleSpeed: data.double_speed,
          duration: data.duration
        }
        sessionStorage.setItem('searchInfo', JSON.stringify(this.queryParams))
        this.$router.push({
          path: '/home/play',
          query: {
            data: JSON.stringify(obj)
          }
        })
        fullScreen()
      } else {
        this.tipParmas = {
          tipsVisible: true,
          code: res.data.original.code
        }
      }
    },
    async getTypeList() {
      const res = await getSectionList({
        size: 0,
        status: 1,
        hospital_id: localStorage.getItem('hospital_id'),
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret')
      })
      this.typeList = res.data;
      this.typeList.unshift({
        title: '全部',
        id: ''
      })
    },
    async getIdenticalList() {
      const res = await getApps({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id')
      })
      if (res.code === 200) {
        this.subjectList = res.data;
        this.subjectList.unshift({
          label: '全部',
          value: ''
        })
      }
    },
    async getInfo() {
      const res = await userVideoStatistics({
        hospital_id: localStorage.getItem('hospital_id'),
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret')
      });
      this.vedioObj = res.data;
    },
    async getList() {
      const res = await userVideoList({
        title: this.queryParams.title,
        app_id: this.queryParams.app_id,
        section_id: this.queryParams.section_id,
        status: this.queryParams.status,
        page: this.queryParams.page,
        size: this.queryParams.size,
        hospital_id: localStorage.getItem('hospital_id'),
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret')
      })
      this.vedioList = res.data.data;
      this.queryParams.total = res.data.total;
    },
    resetQuery() {
      this.$refs['queryForm'].resetFields();
      this.getList();
    }
  }
}
</script>
  <style>

  </style>
  <style lang="scss" scoped>
  ::v-deep{
      .cards .el-card__body{
          display: flex;
      }
  }
  .content{
      // background-color: #F7F8FA;
      padding: 16px;
      // height: 100%;
      .top{
          display: flex;
          justify-content: space-between;
          margin-bottom: 16px;
          .cards{
              width: 24%;
              background-color: #fff;
              .vedio_img{
                  width: 80px;
                  height: 80px;
              }
              .datas{
                  margin-left: 16px;
                  font-size: 28px;
                  color: #303030;
                  .tips{
                      font-size: 14px;
                      color: #BFBFBF;

                      margin-left: 6px;
                  }
                  .name{
                      font-size: 14px;
                      color: #606060;
                      margin-top: 20px;
                  }
              }
          }
      }
  }
  .vedio_list{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .vedio_item{
          width: 49%;
          margin-bottom: 24px;
          .titles{
              padding: 14px 12px;
              background: #F7F8FA;
              border-radius: 12px 12px 0px 0px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .tip{
                  display: inline-block;
                  background: #DD594A;
                  border-radius: 4px 4px 4px 4px;
                  font-size: 10px;
                  color: #FFFFFF;
                  padding: 2px;
                  margin-right: 8px;
              }
              .name{
                font-weight: 500;
                font-size: 18px;
                color: #303030;
                display: flex;
                align-items: center;
                width: 85%;
                .name_set{
                  width: 85%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

            }
              .status{
                  background: #fff;
                  border-radius: 2px 2px 2px 2px;
                  border: 1px solid #EEEEEE;
                  font-size: 14px;
                  color: #BFBFBF;
                  padding: 2px 4px;
              }
              .status2{
                  background: #EAF4FE;
                  border-radius: 2px 2px 2px 2px;
                  border: 1px solid #D6E8FD;
                  font-size: 14px;
                  color: #4190F7;
                  padding: 2px 4px;
              }
              .status3{
                  background: #EBF9F1;
                  border-radius: 2px 2px 2px 2px;
                  border: 1px solid #D7F4E1;
                  font-size: 14px;
                  color: #5FCA71;
                  padding: 2px 4px;
              }
          }
          .vedio_content{
              border-radius: 0 0 12px 12px;
              box-shadow: 0px 4px 12px 0px #F7F8FA;
              .vedio_conten_bottom{
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  font-size: 12px;
                  color: #909090;
                  padding: 8px 16px;
                  .name{
                      color: #303030;
                  }
                  .section{
                    width: 60%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
              }
              .vedio_conten_center{
                  border-bottom: 1px solid #eeeeee;
                  display: flex;
                  justify-content: space-between;
                  padding: 20px 16px;

              }
              .vedio_left{
                  display: flex;
                  align-items: center;
                  width: calc(100% - 95px);
                  .vedio_box{
                    position: relative;
                    width: 150px;
                    height: 106px;
                    border-radius: 8px 8px 8px 8px;
                    cursor: pointer;
                    .vedio_imgs{
                      width: 150px;
                      height: 106px;
                      border-radius: 8px;
                  }
                    .play{
                      width: 40px;
                      height: 40px;
                      position: absolute;
                      top: 34px;
                      left: 55px;
                    }
                  }
                  .vedio_info{
                      margin-left: 12px;
                      width: 100%;
                      padding-right: 12px;
                      .vedio_title{
                          font-weight: 500;
                          font-size: 14px;
                          color: #303030;
                          span{
                              margin-right: 20px;
                          }
                      }
                      .vedio_num{
                          background: #F7F8FA;
                          border-radius: 8px 8px 8px 8px;
                          padding: 8px 12px;
                          margin-top: 12px;
                          font-size: 14px;
                          color: #606060;
                          .item{
                              margin-bottom: 12px;
                          }
                      }
                  }
                  .bor{
                      width: 1px;
                      height: 74px;
                      background-color: #eeeeee;
                      margin-right: 20px;
                  }
              }
              .vedio_right{
                  display: flex;
                  align-items: center;
                  width: 95px;
                  .infos{
                      text-align: center;
                      .title{
                          font-size: 12px;
                          color: #BFBFBF;
                          margin-bottom: 4px;
                      }
                      .rate1{
                          font-size: 14px;
                          color: #BFBFBF;
                      }
                      .rate3{
                          font-size: 14px;
                          color: #5FCA71;
                      }
                      .rate2{
                          font-size: 14px;
                          color: #4190F7;
                      }
                      .time1{
                          font-size: 14px;
                          color: #BFBFBF;
                      }
                      .time2{
                          font-size: 14px;
                          color: #606060;
                      }
                      .bors{
                          width: 36px;
                          height: 1px;
                          background-color: #eeeeee;
                          margin: 10px auto;
                      }
                  }
              }
          }
      }
  }
  .formClass{
      .el-input,.el-select{
          width: 160px;
      }
          ::v-deep{
      .el-form{
        margin: 20px 0;
      }
      .el-form-item--medium .el-form-item__label{
        line-height: 1;
      }
      .el-form-item--medium .el-form-item__content{
        line-height: 1;
      }
     }
  }
  .formTop {
    display: flex;
    justify-content: space-between;

    .formInput {
      display: flex;
    }
  }
  ::v-deep .formClass .el-form-item {
      margin: 0 16px 16px 0;
    }
  ::v-deep .formClass .el-form-item__label{
      line-height: 1;
  }
  ::v-deep .card2 .el-card__body{
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .btn_item{
      display: flex;
      align-items: flex-end;
      margin-right: 0 !important;

    }
  .nodata{
    padding: 100px 0;
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    .img{
      width:250px
    }
    .tips{
      font-size: 16px;
      color: #606060;
      margin-top: 10px;
      width: 100%;
      text-align: center;
    }
  }
  </style>
